import axios from 'axios';
import React, { useEffect, useState } from 'react';

const ManageTeachers = () => {
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentTeacher, setCurrentTeacher] = useState(null);
  const [teachers, setTeachers] = useState([]);

  const [form, setForm] = useState({
    full_name: '',
    email: '',
    password: ''
  });

  useEffect(() => {
    fetchTeachers();
  }, []);

  const fetchTeachers = async () => {
    const res = await axios.get('http://localhost:8081/api/admin/teachers');
    setTeachers(res.data);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    // Input validations
    const nameRegex = /^[A-Za-z\s]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.full_name.trim() || !nameRegex.test(form.full_name)) {
      alert("Please enter a valid full name (letters and spaces only).");
      return;
    }

    if (!emailRegex.test(form.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!isEditMode && form.password.length < 6) {
      alert("Password must be at least 6 characters long.");
      return;
    }

    try {
      if (isEditMode && currentTeacher) {
        await axios.put(`http://localhost:8081/api/admin/teachers/${currentTeacher.id}`, form);
      } else {
        console.log("user being created!");
        
        await axios.post('http://localhost:8081/api/admin/teachers', form);
      }

      setShowModal(false);
      setForm({ full_name: '', email: '', password: '' });
      setCurrentTeacher(null);
      fetchTeachers();
    } catch (error) {
      console.error('Error saving teacher:', error);
      alert("Failed to save teacher. Please try again.");
    }
  };


  const handleDelete = async (id) => {
    await axios.delete(`http://localhost:8081/api/admin/teachers/${id}`);
    fetchTeachers();
  };

  return (
    <div className="manage-teachers">
      <div className="header">
        <h2>Manage Teachers</h2>
        <button
          className="add-btn"
          onClick={() => {
            setIsEditMode(false);
            setForm({ full_name: '', email: '', password: '' });
            setCurrentTeacher(null);
            setShowModal(true);
          }}
        >
          + Add Teacher
        </button>
      </div>

      <table className="teachers-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {teachers.map((teacher) => (
            <tr key={teacher.id}>
              <td>{teacher.full_name}</td>
              <td>{teacher.email}</td>
              <td>
                <button
                  className="edit"
                  onClick={() => {
                    setCurrentTeacher(teacher);
                    setForm({
                      full_name: teacher.full_name,
                      email: teacher.email,
                      password: ''
                    });
                    setIsEditMode(true);
                    setShowModal(true);
                  }}
                >
                  Edit
                </button>
                <button className="delete" onClick={() => handleDelete(teacher.id)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div className="manage-teachers__modal-overlay">
          <div className="manage-teachers__modal">
            <h3>{isEditMode ? 'Edit Teacher' : 'Add Teacher'}</h3>
            <input
              type="text"
              name="full_name"
              placeholder="Full Name"
              value={form.full_name}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
            />

            <div className="manage-teachers__modal-actions">
              <button
                onClick={() => {
                  setShowModal(false);
                  setCurrentTeacher(null);
                  setForm({ full_name: '', email: '', password: '' });
                  setIsEditMode(false);
                }}
                className="cancel-btn"
              >
                Cancel
              </button>
              <button className="save-btn" onClick={handleSave}>
                {isEditMode ? 'Update' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageTeachers;
